import { AxiosPromise, AxiosResponse, ResponseType } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import INTEGRATION from 'SharedDir/backend/endpoints/integration';
import { Integrations } from 'SharedDir/declarations/integrations';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';

export default class IntegrationPersonApiClass {
  protected readonly endpoints = INTEGRATION.INTEGRATION_PERSON;

  async getResults<Extra extends object>(params: PaginationParams<Extra>) {
    const endpoint = this.endpoints.RESULTS;

    const { data } = (await http({ ...endpoint, params })) as AxiosResponse<
      Paginated<Integrations.PersonIntegrationsResultBare>
    >;

    return data;
  }

  async getResultsActual(params: Record<string, unknown>) {
    const endpoint = this.endpoints.RESULTS_ACTUAL;

    const { data } = (await http({ ...endpoint, params })) as AxiosResponse<{
      data: Integrations.PersonIntegrationsResultBare[];
    }>;

    return data;
  }
}
